'use strict';

angular.module('ecrd.queries')
    .component('queriesMain', {
        templateUrl: 'modules/queries/components/main/template.html',
        controller: 'queriesMainController',
        bindings: {
            redirectToRecord: '&',
        },
    });
